import React, { useState } from 'react'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import { capitalizeFirstLetter } from './CapitalizeFirstLetter'
import UpdatePersonExtendedInfo from '../../../Services/Mutations/UpdatePersonExtendedInfo'
import { ToastStyle } from '../../Data/MovieStaticData'
import { toast } from 'react-toastify'
import { Auth } from 'aws-amplify'
import AchivementsUi from './AchivementsUi'
let loggedInUserHandle = ''
const loggedInUserEmail = Auth.user && Auth.user.attributes ? Auth.user.attributes.email : ''
if (loggedInUserEmail) {
  const emailParams = loggedInUserEmail.split('@')
  loggedInUserHandle = '@' + emailParams[0]
}

function AwardsInfo({
  data,
  setData,
  section,
  activeSection,
  handleSectionClick,
  label,
  getUpdatedData,
  personData,
  setLoader,
}) {
  const [changesMade, setChangesMade] = useState(false)
  // Function to handle editing of an item in the data structure
  const handleItemEdit = ({ questionIndex, answerIndex, field, value, lang }) => {
    // Make a copy of the original data to avoid mutating it directly
    const updatedData = [...data]
    // Update the specific field of the item in the specified language
    if (field === 'awardYear') {
      const valueIsNumber = !isNaN(value)

      // Then, if value is indeed a number, you can parse it:
      if (valueIsNumber && value) {
        updatedData[questionIndex][`answerItems_${lang}`][answerIndex][field] = parseInt(value, 10)
      } else {
        // Handle the case where value is not a valid number.
        updatedData[questionIndex][`answerItems_${lang}`][answerIndex][field] = ''
      }
    } else {
      updatedData[questionIndex][`answerItems_${lang}`][answerIndex][field] = value
    }

    setChangesMade(true)
    // Update the state with the modified data
    setData(updatedData)
  }

  // Function to handle adding a new item to the data structure
  const handleAddItem = questionIndex => {
    // Make a copy of the original data to avoid mutating it directly
    const updatedData = [...data]
    // Check if answer items are null and initialize them as empty arrays if they are
    if (!updatedData[questionIndex].answerItems_En) {
      updatedData[questionIndex].answerItems_En = []
    }

    if (!updatedData[questionIndex].answerItems_Te) {
      updatedData[questionIndex].answerItems_Te = []
    }

    // Add a new item to the 'En' and 'Te' arrays of answer items for the specified question
    updatedData[questionIndex].answerItems_En.push({
      awardYear: '',
      awardTitle_En: '',
      awardsBasicInfo_En: '',
    })
    updatedData[questionIndex].answerItems_Te.push({
      awardYear: '',
      awardTitle_Te: '',
      awardsBasicInfo_Te: '',
    })

    // Update the state with the modified data
    setData(updatedData)
  }

  const SubmitAwards = async () => {
    setLoader(true)
    // Construct the input object with necessary data for the update
    const input = {
      PK: personData.PK,
      SK: personData.SK,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
    }

    // Initialize an object to hold the label input data
    const labelInput = {}

    // Loop through each item in personalAndBackGroundInfo
    data.forEach(item => {
      // If the item has a field in English and answerItems_En is present and not empty
      if (
        item.field_En &&
        item.answerItems_En &&
        Array.isArray(item.answerItems_En) &&
        item.answerItems_En.length > 0
      ) {
        const answerItemsEn = []
        // Loop through each item in the answerItems_En array
        item.answerItems_En.forEach(answer => {
          // Check if the required fields are present in the answer item
          const answerInput = {}
          if (answer.awardYear || answer.awardTitle_En || answer.awardsBasicInfo_En) {
            // Add the values to labelInput
            answerInput.awardYear = answer.awardYear ? answer.awardYear : null
            answerInput.awardTitle_En = answer.awardTitle_En ? answer.awardTitle_En : null
            answerInput.awardsBasicInfo_En = answer.awardsBasicInfo_En
              ? answer.awardsBasicInfo_En
              : null
            answerItemsEn.push(answerInput)
          }

          labelInput[item.field_En] = answerItemsEn.length > 0 ? answerItemsEn : null
        })
      }

      // // If the item has a field in English and an answer in English
      // if (item.field_En && item.answerItems_En && item.answerItems_En.toString()) {
      //   // Add the English field and answer to labelInput
      //   labelInput[item.field_En] = item.answerItems_En
      // }
      if (
        item.field_Te &&
        item.answerItems_Te &&
        Array.isArray(item.answerItems_Te) &&
        item.answerItems_Te.length > 0
      ) {
        const answerItemsTe = []
        // Loop through each item in the answerItems_En array
        item.answerItems_Te.forEach(answer => {
          // Check if the required fields are present in the answer item
          const answerInput = {}
          if (answer.awardYear || answer.awardTitle_Te || answer.awardsBasicInfo_Te) {
            // Add the values to labelInput
            answerInput.awardYear = answer.awardYear ? answer.awardYear : null
            answerInput.awardTitle_Te = answer.awardTitle_Te ? answer.awardTitle_Te : null
            answerInput.awardsBasicInfo_Te = answer.awardsBasicInfo_Te
              ? answer.awardsBasicInfo_Te
              : null
            answerItemsTe.push(answerInput)
          }

          labelInput[item.field_Te] = answerItemsTe.length > 0 ? answerItemsTe : null
        })
      }

      //   // If the item has a field in Telugu and an answer in Telugu
      //   if (item.field_Te && item.answerItems_Te && item.answerItems_Te.toString()) {
      //     // Add the Telugu field and answer to labelInput
      //     labelInput[item.field_Te] = item.answerItems_Te
      //   }
    })

    // Add the label input data to the input object
    input[label] = labelInput

    try {
      // Call the UpdatePersonExtendedInfo mutation with the input data
      const update = await UpdatePersonExtendedInfo(input)

      // Check if the update was successful
      if (update.statusCode === '200') {
        // If successful, display success message
        toast.success(`${update.statusMessage}`, ToastStyle)
        // Reload the window to reflect the changes
        // window.location.reload(false)
        getUpdatedData()
        setLoader(false)
      } else {
        setLoader(false)
        // If update failed, display error message
        toast.error('Failed to update. Please try again.')
      }

      // Log the update response
    } catch (error) {
      // Catch any errors that occur during the update process
      console.error('Error in SubmitExtendedInfo:', error.message)
    }
  }

  return (
    <div
      id={section}
      className={`accordion-item ${
        activeSection === section || activeSection === 'all' ? 'active' : ''
      }`}
    >
      <h2 className='accordion-header' id='headingOne'>
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseOne'
          aria-expanded={activeSection === section || activeSection === 'all'}
          aria-controls='collapseOne'
          onClick={() => handleSectionClick(section)}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            color: 'white',
          }}
        >
          <span>{capitalizeFirstLetter(label)}</span>

          {activeSection === section || activeSection === 'all' ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </h2>
      <div
        id='collapseOne'
        className={`accordion-collapse collapse ${
          activeSection === section || activeSection === 'all' ? 'show' : ''
        }`}
        aria-labelledby='headingOne'
        data-bs-parent='#accordion'
      >
        <AchivementsUi data={data} handleItemEdit={handleItemEdit} handleAddItem={handleAddItem} />
        <div
          className='d-flex'
          style={{ justifyContent: 'center', alignItems: 'center', gap: '5px', marginTop: '5px' }}
        >
          <button
            className='btn btn-success'
            onClick={() => {
              setChangesMade(false)
              SubmitAwards()
            }}
            disabled={!changesMade}
          >
            save
          </button>
          <button
            className='btn btn-secondary'
            disabled={!changesMade}
            onClick={() => {
              setChangesMade(false)
              getUpdatedData()
            }}
          >
            cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default AwardsInfo
